import { render, staticRenderFns } from "./CustomAccordion.vue?vue&type=template&id=888c4734&"
import script from "./CustomAccordion.vue?vue&type=script&lang=js&"
export * from "./CustomAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports